
import ConfigurableColumn from 'SharedComponents/Table/ConfigurableColumn.vue';
import { useValue } from 'SharedDir/common/composables/useValue';
import { QuasarTableColumn, TableSettings } from 'SharedDir/declarations/shared';
import { VisibleColumnItem } from 'SharedDir/stores/settings.store';
import { defineComponent, PropType } from 'vue';
import draggable from 'vuedraggable';

export default defineComponent({
  name: 'ColumnSettings',
  components: {
    ConfigurableColumn,
    draggable,
  },
  props: {
    modelValue: {
      type: Object as PropType<TableSettings>,
      required: true,
    },
    columns: {
      required: true,
      type: Array as PropType<QuasarTableColumn[]>,
    },
    alwaysVisible: {
      type: Array as PropType<string[]>,
      default: () => ['actions'],
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    function makeColumnItem(column: QuasarTableColumn, visible): VisibleColumnItem {
      return {
        name: column.name,
        label: column.label,
        show: visible,
      };
    }
    function transform(v: TableSettings): VisibleColumnItem[] {
      if (v && Array.isArray(v.hiddenColumns) && Array.isArray(v.columnsOrder)) {
        const dict = Object.fromEntries(props.columns.map((c) => [c.name, c]));
        const keys =
          v.columnsOrder.length !== props.columns.length ? Object.keys(dict) : v.columnsOrder;
        return keys.map((k) => makeColumnItem(dict[k], !v.hiddenColumns.includes(dict[k].name)));
      }
      return props.columns.map((c) => makeColumnItem(c, true));
    }

    function mrofsnart(iv: VisibleColumnItem[]): TableSettings {
      const hiddenColumns = iv.filter(({ show }) => !show).map(({ name }) => name);
      const columnsOrder = iv.map(({ name }) => name);
      return {
        hiddenColumns,
        columnsOrder,
      };
    }
    const { innerValue, emitValue } = useValue<TableSettings, VisibleColumnItem[]>(props, emit, {
      transform,
      mrofsnart,
    });

    return {
      innerValue,
      emitValue,
    };
  },
});
